import { observable } from 'mobx'

const Profile = observable({
  isAuthenticated: false,
  profile: null,
  token: null,
  expires_at: null
})

export default Profile;